
const mockConfigs = [
]

mockConfigs.forEach(mockConfig => {
  if (mockConfig.enabled === false) {
    return
  }
  mockConfig.initMocks()
})

export default {}



// WEBPACK FOOTER //
// ./src/mock.js